import { Button } from "@/components/common"
import * as Sentry from "@sentry/browser"
import React, { useState } from "react"
import { useAsyncCallback } from "react-async-hook"
import { useNavigate } from "react-router-dom"
import { useApp } from "../AppProvider"
import { useApi } from "../hooks/useApi"

export const Login: React.FC = () => {
  const { setToken, setMembership, setUser, addToast } = useApp()
  const { login } = useApi()

  const navigate = useNavigate()

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const onSubmitAsync = useAsyncCallback(async () => {
    const result = await login(email, password)
    setToken(result.token)
    setUser(result.user)
    Sentry.setUser({ email: result.user?.email || "unknown", id: result.user?._id || "unknown" })

    if (!result.memberships || result.memberships.length === 0) {
      addToast("Error", "This account does not belong to any active organizations", "error")
      return
    }

    // Always take the first membership for now
    if (result.memberships?.[0]) {
      setMembership(result.memberships[0])
    }

    // Redirect to super admin or dashboard based on user role

    navigate(
      result.user?.superAdmin ? "/private" : `/organizations/${result.memberships[0].organization}/dashboard`,
    )

    return result
  })

  const onSubmit = (e: any) => {
    e.preventDefault()
    if (onSubmitAsync.loading) return
    onSubmitAsync.execute()
  }

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="card mx-auto w-full max-w-lg">
        <form onSubmit={onSubmit}>
          <div>
            <strong>Sierra Vet Login</strong>
          </div>
          <div className="mt-3">
            <div>
              <label htmlFor="email" className="label">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="john@mail.com"
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                required
                className="input"
              />
            </div>
            <div className="mt-3">
              <label htmlFor="password" className="label">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                required
                className="input"
              />
            </div>
            {onSubmitAsync.error && (
              <div className="error-message mt-2">{onSubmitAsync.error.message || "Unexpected Error"}</div>
            )}
            <div className="mt-5"></div>
            <Button
              type="submit"
              disabled={onSubmitAsync.loading}
              className="bg-primary-700 flex w-full items-center justify-center">
              {onSubmitAsync.loading ? "Loading..." : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
